function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["alignment", "alt", "backgroundColor", "className", "customStyle", "height", "fullWidth", "loading", "loadingAspectRatio", "loadingHeight", "loadingWidth", "maxHeight", "maxWidth", "onImageLoad", "objectFit", "objectPosition", "outputFormat", "preset", "quality", "responsive", "src", "sizes", "transformation", "uiTheme", "width", "style", "shimmerOnLoad"];
var _templateObject, _templateObject2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import styled from 'styled-components';
import { identity, pickBy, get } from 'lodash';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import ImageResizer from '../ImageResizer';
import Shimmer from '../Shimmer';
import withTheme from '../Theme/withTheme';
import ImageBrokenIcon from '../Icons/ImageBroken';
import ImageContainer from './image-container';
import { getSizes, getSrcSet, getTransformedProps, getAlignmentParam, getAspectRatio } from './utils';
var StyledImage = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  height: inherit;\n  width: inherit;\n  max-height: inherit;\n  max-width: inherit;\n  opacity: ", ";\n  transition: opacity 0.25s ease-in-out;\n  ", "\n"])), function (props) {
  return props.hasLoaded ? 1 : 0;
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    if (breakpointProps.transformation === 'fit' || breakpointProps.fullWidth === false) {
      return 'margin-top: 0;';
    }
    if (breakpointProps.fullWidth) {
      return "\n          margin-top: ".concat(getAspectRatio(breakpointProps.height, breakpointProps.width) * -100, "%;\n          display: block;\n        ");
    }
    return '';
  });
});
var BlurredBackground = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-image: url(", ");\n  background-position: center;\n  background-size: cover;\n  filter: blur(20px);\n  transition: background-image 0.75s ease-in-out;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"])), function (props) {
  return props.src;
});
var isServer = function isServer() {
  return typeof window === 'undefined';
};
var Image = /*#__PURE__*/function (_React$Component) {
  function Image(props) {
    var _this;
    _classCallCheck(this, Image);
    _this = _callSuper(this, Image, [props]);
    _defineProperty(_this, "handleImageLoaded", function () {
      var hasLoaded = _this.state.hasLoaded;
      if (!hasLoaded) {
        var newState = {
          hasLoaded: true,
          currentSrc: get(_this.image, 'current.currentSrc', '')
        };
        if (_this.image.current) {
          newState.currentSrc = _this.image.current.currentSrc;
          newState.aspectRatio = _this.image.current.clientHeight / _this.image.current.clientWidth;
        }
        _this.setState(newState);
      }
      var onImageLoad = _this.props.onImageLoad;
      onImageLoad(_this.image.current);
    });
    _defineProperty(_this, "getImageUrl", function (url, h, w, t, bg, a, q, o) {
      var excludedImageTypesFromResizing = ['svg'];
      var options = pickBy({
        h: h,
        w: w,
        t: t,
        a: getAlignmentParam(a),
        q: q,
        o: o
      }, identity);
      if (t === 'frame' && bg) {
        options.bg = bg.substring(1);
      }

      // if we have a specific image type which is excluded
      var hasExcludedImageTypeFromResizing = excludedImageTypesFromResizing.some(function (imageType) {
        return url.includes(".".concat(imageType));
      });
      if (hasExcludedImageTypeFromResizing) {
        return url;
      }
      return ImageResizer.resizeUrl(url, options);
    });
    _defineProperty(_this, "isMorePortrait", function (presetRatio) {
      var aspectRatio = _this.state.aspectRatio;
      return aspectRatio && aspectRatio > presetRatio;
    });
    _this.state = {
      hasLoaded: isServer(),
      aspectRatio: null
    };
    _this.image = /*#__PURE__*/React.createRef();
    return _this;
  }
  _inherits(Image, _React$Component);
  return _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var img = this.image.current;
      if (img && img.complete) {
        this.handleImageLoaded();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = getTransformedProps(this.props);
      var alignment = props.alignment,
        alt = props.alt,
        backgroundColor = props.backgroundColor,
        className = props.className,
        customStyle = props.customStyle,
        height = props.height,
        fullWidth = props.fullWidth,
        loading = props.loading,
        loadingAspectRatio = props.loadingAspectRatio,
        loadingHeight = props.loadingHeight,
        loadingWidth = props.loadingWidth,
        maxHeight = props.maxHeight,
        maxWidth = props.maxWidth,
        onImageLoad = props.onImageLoad,
        objectFit = props.objectFit,
        objectPosition = props.objectPosition,
        outputFormat = props.outputFormat,
        preset = props.preset,
        quality = props.quality,
        responsive = props.responsive,
        src = props.src,
        sizes = props.sizes,
        transformation = props.transformation,
        uiTheme = props.uiTheme,
        width = props.width,
        style = props.style,
        shimmerOnLoad = props.shimmerOnLoad,
        otherProps = _objectWithoutProperties(props, _excluded);
      var _this$state = this.state,
        hasLoaded = _this$state.hasLoaded,
        currentSrc = _this$state.currentSrc;
      var containerProps = {
        className: className,
        hasLoaded: hasLoaded,
        height: height,
        fullWidth: fullWidth,
        loadingAspectRatio: loadingAspectRatio,
        loadingHeight: loadingHeight,
        loadingWidth: loadingWidth,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        responsive: responsive,
        style: style,
        transformation: transformation,
        width: width
      };
      if (!src) {
        return /*#__PURE__*/React.createElement(ImageContainer, _extends({}, containerProps, {
          style: {
            backgroundColor: backgroundColor
          }
        }), /*#__PURE__*/React.createElement(ImageBrokenIcon, {
          color: "#C5C5C5",
          size: 48,
          style: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }
        }));
      }
      var imageStyle = {
        objectFit: objectFit,
        objectPosition: objectPosition,
        marginTop: fullWidth ? "".concat(getAspectRatio(height, width) * -100, "%") : '0'
      };

      // When using a fit transformation we want the image to float within the container and not be stretched
      if (transformation === 'fit') {
        imageStyle.height = this.isMorePortrait(height / width) ? '100%' : 'auto';
        imageStyle.width = this.isMorePortrait(height / width) ? 'auto' : '100%';
        imageStyle.position = 'absolute';
        imageStyle.left = '50%';
        imageStyle.transform = 'translate(-50%, -50%)';
        imageStyle.top = '50%';
        imageStyle.marginTop = '0';
      }
      if (props.heroImage) {
        imageStyle.display = 'block';
        imageStyle.width = 'inherit';
        imageStyle.height = 'inherit';
        imageStyle.maxWidth = 'inherit';
        imageStyle.maxHeight = 'inherit';
        imageStyle.opacity = hasLoaded ? 1 : 0;
        return /*#__PURE__*/React.createElement(ImageContainer, _extends({}, containerProps, {
          hasLoaded: hasLoaded
        }), !hasLoaded && shimmerOnLoad && /*#__PURE__*/React.createElement(Shimmer, {
          height: "100%",
          width: "100%",
          style: {
            position: 'absolute',
            top: 0,
            left: 0
          }
        }), transformation === 'fit' && currentSrc && /*#__PURE__*/React.createElement(BlurredBackground, {
          src: currentSrc
        }), /*#__PURE__*/React.createElement("img", {
          src: this.getImageUrl(src, height, width, transformation, backgroundColor, alignment, quality, outputFormat),
          alt: alt,
          loading: loading,
          ref: this.image,
          sizes: getSizes(src, responsive, width, uiTheme),
          srcSet: getSrcSet(src, responsive, height, width, transformation, backgroundColor, alignment, quality, outputFormat),
          style: imageStyle,
          onLoad: this.handleImageLoaded,
          height: height,
          width: width,
          fetchPriority: "high"
        }));
      }
      return /*#__PURE__*/React.createElement(ImageContainer, _extends({}, containerProps, {
        hasLoaded: hasLoaded
      }), !hasLoaded && shimmerOnLoad && /*#__PURE__*/React.createElement(Shimmer, {
        height: "100%",
        width: "100%",
        style: {
          position: 'absolute',
          top: 0,
          left: 0
        }
      }), transformation === 'fit' && currentSrc && /*#__PURE__*/React.createElement(BlurredBackground, {
        src: currentSrc
      }), /*#__PURE__*/React.createElement(StyledImage, _extends({
        hasLoaded: hasLoaded,
        uiTheme: uiTheme,
        responsive: responsive,
        src: this.getImageUrl(src, height, width, transformation, backgroundColor, alignment, quality, outputFormat),
        alt: alt,
        loading: loading,
        ref: this.image,
        sizes: getSizes(src, responsive, width, uiTheme),
        srcSet: getSrcSet(src, responsive, height, width, transformation, backgroundColor, alignment, quality, outputFormat),
        style: imageStyle,
        onLoad: this.handleImageLoaded,
        height: height,
        width: width
      }, otherProps)));
    }
  }]);
}(React.Component);
Image.defaultProps = {
  alignment: null,
  backgroundColor: null,
  className: null,
  fullWidth: false,
  height: null,
  loading: 'auto',
  loadingAspectRatio: null,
  loadingHeight: null,
  loadingWidth: null,
  maxHeight: null,
  maxWidth: null,
  objectFit: undefined,
  objectPosition: undefined,
  onImageLoad: function onImageLoad() {},
  outputFormat: null,
  preset: null,
  quality: null,
  responsive: [],
  shimmerOnLoad: false,
  src: null,
  style: {},
  transformation: null,
  uiTheme: null,
  width: null,
  heroImage: false
};
Image.displayName = 'Image';
export default withTheme(Image);